<template>
  <q-dialog
    ref="dialogRef"
    v-bind="dialogProps"
    v-model="isVisible"
    :persistent="isPersistent"
  >
    <q-card
      class="full-width full-height column"
    >
      <q-card-section class="q-px-lg col">
        <slot />
      </q-card-section>
      <div
        v-if="actions && actions?.filter(a => a.show !== false).length > 0"
        class="action-footer"
      >
        <div class="triangle" />
        <q-separator />
        <q-card-actions
          align="right"
          class="tooltip-actions"
        >
          <q-btn
            v-for="action,i in actions"
            v-show="action.show ?? true"
            :key="i"
            :label="action.label"
            :outline="action.outline"
            unelevated
            class="wlk-btn"
            v-bind="action.btnProps"
            @click="action.handler"
          />
        </q-card-actions>
      </div>
    </q-card>
  </q-dialog>
</template>
<script setup>
import { ref, computed, toRef, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: () => false
  },
  contextName: {
    type: String,
    default: () => null
  },
  dialogReference: {
    type: Object,
    default: () => null
  },
  dialogProps: {
    type: Object,
    default: () => { }
  },
  actions: {
    type: Array,
    default: () => null
  }
})

const emit = defineEmits(['update:modelValue', 'update:dialogReference'])
const modelValueRef = toRef(props, 'modelValue')
const closableWhileLoadingRef = toRef(props, 'closableWhileLoading')
const loadingRef = toRef(props, 'loading')
const dialogRef = ref(null)
const isVisible = ref(false)

watch(isVisible, v => emit('update:modelValue', v))
watch(modelValueRef, v => {
  isVisible.value = v
})

if (props.dialogReference) {
  dialogRef.value = props.dialogReference
}

watch(dialogRef, v => {
  emit('update:dialogReference', v)
})

const isPersistent = computed(() => !closableWhileLoadingRef.value && loadingRef.value)
</script>
<style lang="scss">
.triangle::before {
  content: "";
  position: absolute;
  width:0;
  height:0;
  right: 90px;
  -webkit-transform:rotate(360deg);
  transform:rotate(360deg);
  border-style: solid;
  border-width: 12px 10px 0 10px;
  border-color: white transparent transparent transparent;
}

.tooltip-actions {
  background-color: var(--q-primary);

  .q-btn {
    min-width: 80px !important;
    flex: none !important;
  }
}
</style>
